import { isFunction } from 'underscore';
import React, { useCallback, useEffect, useMemo } from 'react';
import { Prompt } from 'react-router-dom';

export const useNavigationConfirmationPrompt = (needsConfirmation, confirmationMessage) => {
  const onUserNavigation = useCallback((location, action) => {
    if ((isFunction(needsConfirmation) && needsConfirmation(location, action)) || needsConfirmation) {
      return confirmationMessage;
    }
    return true;
  }, [needsConfirmation, confirmationMessage]);

  const navigationConfirmationPrompt = useMemo(() => (
    <Prompt message={onUserNavigation} />
  ), [onUserNavigation]);

  const beforeUnloadListener = useCallback((event) => {
    event.preventDefault();
    // eslint-disable-next-line no-param-reassign
    event.returnValue = confirmationMessage;
    return confirmationMessage;
  }, [confirmationMessage]);
  useEffect(() => {
    if (needsConfirmation) {
      addEventListener('beforeunload', beforeUnloadListener, { capture: true });
    } else {
      removeEventListener('beforeunload', beforeUnloadListener, { capture: true });
    }

    return () => {
      removeEventListener('beforeunload', beforeUnloadListener, { capture: true });
    };
  }, [needsConfirmation, beforeUnloadListener]);

  return navigationConfirmationPrompt;
};
